import Cookies from 'js-cookie';

export const TOKEN = Cookies.get('token');

export default TOKEN;
